import { Close } from "@mui/icons-material";
import { Dialog, DialogTitle, IconButton } from "@mui/material";

const BaseDialog = ({ open, config, onClose, title, children }) => {
  return (
    <Dialog
      open={open}
      aria-labelledby="dialog"
      aria-describedby="add or accept"
      slotProps={config.slotProps}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={() => ({
          position: "absolute",
          right: 8,
          top: 8,
        })}
      >
        <Close sx={{ width: "20px", heigth: "20px", color: "text.primary" }} />
      </IconButton>
      <DialogTitle
        id="dialog-title"
        sx={{ fontWeight: "bold", fontSize: "20px" }}
      >
        {title}
      </DialogTitle>
      {
        <div
          style={{
            flex: 1,
            width: "100%",
            overflowX: "auto",
            marginTop: 8,
          }}
        >
          {children}
        </div>
      }
    </Dialog>
  );
};

export default BaseDialog;
